import { Page } from "@/interfaces/page";
import { StudioState } from "@/interfaces/studioState";
import Axios from "axios";

export class ReportService {
    public static async getReport(id: string, token: string) {
        const uri = `/api/report/by_id/${id}`;
        const response = await Axios.get(uri, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    }

    public static async getReports(token: string) {
        const uri = `/api/report/all`;
        const response = await Axios.get(uri, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    }

    public static async createReport(
        name: string,
        ownerId: string,
        studioId: string,
        reportData:
            | Page[]
            | Omit<
                  StudioState,
                  | "presenters"
                  | "users"
                  | "quick_connect_codes"
                  | "healthySession"
              >[],
        token: string
    ) {
        const uri = "/api/report";
        const response = await Axios.post(
            uri,
            { name, ownerId, studioId, reportData },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;
    }

    public static async createOverallReport(
        name: string,
        ownerId: string,
        token: string
    ) {
        const uri = "/api/report/overall";
        const response = await Axios.post(
            uri,
            { name, ownerId },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response;
    }

    public static async eventReport(eventId: string, token: string) {
        const uri = `/api/report/event/${eventId}`;
        const response = await Axios.get(uri, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response;
    }

    public static async deleteReport(id: string, token: string) {
        const uri = "/api/report";
        const response = await Axios.delete(uri, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                id,
            },
        });
        return response.status === 200;
    }

    public static downloadJSON(
        payload: string,
        filename: string
    ): HTMLAnchorElement {
        const blob = new Blob([payload], { type: "text/plain" });
        const filelink = document.createElement("a");
        filelink.download = `${filename}.json`;
        filelink.href = window.URL.createObjectURL(blob);
        filelink.dataset.downloadurl = [
            "text/json",
            filelink.download,
            filelink.href,
        ].join(":");
        document.body.appendChild(filelink);
        return filelink;
    }
}
